export type EditorCaret = {
  start: number;
  end: number;
  touched: boolean;
};

function clamp(n: number, min: number, max: number): number {
  return Math.min(max, Math.max(min, n));
}

/** テキストエリアの選択範囲へスニペットを挿入する */
export function insertAtSelection(
  source: string,
  snippet: string,
  start: number,
  end: number,
): { next: string; caret: number } {
  const len = source.length;
  const from = clamp(Number.isFinite(start) ? start : 0, 0, len);
  const to = clamp(Math.max(from, Number.isFinite(end) ? end : from), 0, len);
  const next = `${source.slice(0, from)}${snippet}${source.slice(to)}`;
  return { next, caret: from + snippet.length };
}

/**
 * HTML本文へ挿入する。
 * カーソルを置いていればその位置。未操作なら </article> の直前、それも無ければ末尾。
 */
export function insertHtmlSnippet(
  source: string,
  snippet: string,
  caret: EditorCaret,
): { next: string; caret: number } {
  if (caret.touched) {
    return insertAtSelection(source, snippet, caret.start, caret.end);
  }
  const closeIdx = source.toLowerCase().lastIndexOf('</article>');
  if (closeIdx >= 0) {
    return insertAtSelection(source, snippet, closeIdx, closeIdx);
  }
  return insertAtSelection(source, snippet, source.length, source.length);
}

/** 概要などプレーン欄。未操作なら末尾へ足す */
export function insertPlainSnippet(
  source: string,
  snippet: string,
  caret: EditorCaret,
): { next: string; caret: number } {
  if (caret.touched) {
    return insertAtSelection(source, snippet, caret.start, caret.end);
  }
  const prefix = source && !source.endsWith('\n') ? '\n' : '';
  return insertAtSelection(source, `${prefix}${snippet}`, source.length, source.length);
}
